import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path
      d="M28 28V4C14.745 4 4 14.745 4 28h24zm-5-6a4 4 0 100-8 4 4 0 000 8zm-4 6a3 3 0 00-6 0M28 8C16.954 8 8 16.954 8 28"
      fill="none"
    />
  </Icon>
);
